import {BrowserRouter , Routes , Route, Navigate} from "react-router-dom"
import { ToastContainer } from "react-toastify";

import Header from './components/header/Header';
import Home from "./pages/home-page/Home";
import Login from "./pages/forms/Login";
import Register from "./pages/forms/Register";
import Attendance from "./pages/attendance-page/Attendance";
import AdminDashboard from "./pages/admin-page/AdminDashboard";
import Users from "./pages/users-page/Users";
import ForgetPassword from "./pages/forms/ForgetPassword";
import ResetPassword from "./pages/forms/ResetPassword";
import NotFound from "./pages/not-found-Page/NotFound";
import { useDispatch, useSelector } from "react-redux";
import Profile from "./pages/users-page/Profile";
import Reports from "./pages/report-page/Reports";
import VerifyEmail from "./pages/verify-email/VerifyEmail";
import Verify2FA from "./pages/2fa/Verify2FA";
import Enable2FA from "./pages/2fa/Enable2FA";
import DailyUpdate from "./pages/daily-update-page/DailyUpdate";
import AdminDailyUpdatesToday from "./pages/admin-page/AdminDailyUpdatesToday";


function App() {

  const {user} = useSelector(state => state.auth)
  const dispatch = useDispatch(); 

  return (
    <BrowserRouter >
      <ToastContainer theme="colored" position="top-center" />
      {user && <Header /> }

      <Routes>
        <Route path="/login" element={!user ? <Login/> : <Navigate to="/attendance" />} />

        <Route path="/verify-2fa" element={<Verify2FA />} />
        <Route path="/enable-2fa" element={<Enable2FA />} />


        <Route path="/users/:userId/verify/:token" element={!user ? <VerifyEmail/> : <Navigate to="/attendance" />} />
        <Route path="/forget-password" element={<ForgetPassword/>} />
        <Route path="/reset-password/:userId/:token" element={<ResetPassword/>} />
        <Route path="/attendance" element={user ? <Attendance/> : <Navigate to="/login" />} />
        <Route path="/users/profile/:id" element={user ? <Profile/> : <Navigate to="/login" />} />
        <Route path="/admin-dashboard" element={user?.isAdmin ? <AdminDashboard/> : <Navigate to="/attendance" />} />
        <Route path="/admin-dashboard/users-list" element={user?.isAdmin ? <Users/> : <Navigate to="/attendance" />} />

        {/* Reports route: accessible to both admin and normal users */}
        <Route path="/admin-dashboard/reports" element={user ? <Reports /> : <Navigate to="/login" />} />

         <Route
  path="/daily-updates"
  element={user ? <DailyUpdate /> : <Navigate to="/login" />}
/>
<Route
  path="/admin-dashboard/daily-updates-today"
  element={
    user?.isAdmin ? (
      <AdminDailyUpdatesToday />
    ) : (
      <Navigate to="/attendance" />
    )
  }
/>

        <Route path="/admin-dashboard/settings" element={user?.isAdmin ? <AdminDashboard/> : <Navigate to="/attendance" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
